<template>
    <div class="panel-success">
        <div class="panel-success__message">
            <base-icon
                name="check-circle"
                size="xxxlarge"
                color="active"
            ></base-icon>
            <h2 class="panel-success__title">{{$t('twitch.queueRequest')}}</h2>
        </div>
        <base-button
            :isType="['simple','install']"
            @onClick="$router.push({ name: 'VoicesList'})"
        >
            <template #label>
                {{$t('twitch.returnToList')}}
            </template>
        </base-button>
    </div>
</template>

<script>
export default {
    name: 'PanelSuccess',
    components: {
        BaseIcon: () => import (/* webpackChunkName: "BaseIcon"*/ '@RepoComponent/BaseIcon/BaseIcon.vue'),
        BaseButton: () => import (/* webpackChunkName: "BaseButton"*/ '@RepoComponent/BaseButton/BaseButton.vue'),
    },
};
</script>

<style src="./PanelSuccess.scss" lang="scss"></style>
